export default __webpack_public_path__ + "static/media/WAS0333.34I-41682_-24961_0.ea2cbdb7.jpg";